import React from 'react';


const ServiceNowConsulting = () => {
    return (
        <section className="lg:py-[80px] py-[50px] px-[20px] lg:px-[0]">
            <div className="w-full max-w-[1280px] mx-auto lg:py-[60px] py-[30px] lg:px-[90px] px-[40px] bg-gradient-to-t from-[#F3F5FF] to-[#E5ECFF] ">
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-[67px]">
                    <div className="w-full md:flex-1 flex justify-center">
                        <img
                            src="/assets/leverage/img1.png"
                            alt="ServiceNow Abstract Art"
                            className="w-full max-w-[529px] h-auto object-cover block"
                        />
                    </div>

                    <div className="w-full md:flex-1 text-[#01386A]">
                        <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] mb-5">
                            ServiceNow Consulting
                        </h2>
                        <p className="text-[14px] lg:text-[16px] font-[500] font-graphik leading-relaxed text-[#49577A]">
                            Boost your business performance with Mobikode ServiceNow consulting services.
                            We take time to understand your goals and tailor ServiceNow to fit your real
                            needs, creating a clear and practical roadmap for smooth digital
                            transformation and lasting operational improvement.
                        </p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ServiceNowConsulting;